import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createReferredFriendRequest = {};
var _createReferredFriendResponse = { referredFriend: '_referredFriend' };
var _deleteReferredFriendRequest = {};
var _deleteReferredFriendResponse = {};
var _getReferredFriendByContactIdRequest = {};
var _getReferredFriendByContactIdResponse = {
    referredFriend: '_referredFriend',
};
var _getReferredFriendRequest = {};
var _getReferredFriendResponse = { referredFriend: '_referredFriend' };
var _queryReferredFriendRequest = {};
var _queryReferredFriendResponse = { referredFriends: '_referredFriend' };
var _referredFriend = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateReferredFriendRequest = {
    mask: 'google.protobuf.FieldMask',
    referredFriend: '_referredFriend',
};
var _updateReferredFriendResponse = { referredFriend: '_referredFriend' };
function resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/referral_friends',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/referral-friends',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/referral_friends',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/referral-friends',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new referred friend or returns an existing entity if it already exists.
 *
 * This method must be called with a [member identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#site-members).
 *
 * A referral code must be provided either in the request or via scope.
 *
 * The member must be eligible to become a referred friend.
 */
export function createReferredFriend(payload) {
    var _a = serializer(_createReferredFriendRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReferredFriendResponse, {
        _referredFriend: _referredFriend,
    }).fromJSON;
    function __createReferredFriend(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referred_friend',
            method: 'POST',
            methodFqn: 'wix.loyalty.referral.friend.v1.ReferredFriends.CreateReferredFriend',
            url: resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl({
                protoPath: '/v1/referred-friends',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReferredFriend.fromReq = fromReq;
    __createReferredFriend.__isAmbassador = true;
    return __createReferredFriend;
}
/** Retrieves a referred friend by ID. */
export function getReferredFriend(payload) {
    var _a = serializer(_getReferredFriendRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferredFriendResponse, {
        _referredFriend: _referredFriend,
    }).fromJSON;
    function __getReferredFriend(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referred_friend',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.friend.v1.ReferredFriends.GetReferredFriend',
            url: resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl({
                protoPath: '/v1/referred-friends/{referredFriendId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferredFriend.fromReq = fromReq;
    __getReferredFriend.__isAmbassador = true;
    return __getReferredFriend;
}
/**
 * Retrieves a referred friend by contact ID.
 *
 * You can use `me` instead of a specific contact ID to get the referred friend for the current identity's contact.
 */
export function getReferredFriendByContactId(payload) {
    var _a = serializer(_getReferredFriendByContactIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferredFriendByContactIdResponse, { _referredFriend: _referredFriend }).fromJSON;
    function __getReferredFriendByContactId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referred_friend',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.friend.v1.ReferredFriends.GetReferredFriendByContactId',
            url: resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl({
                protoPath: '/v1/referred-friends/contact/{contactId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferredFriendByContactId.fromReq = fromReq;
    __getReferredFriendByContactId.__isAmbassador = true;
    return __getReferredFriendByContactId;
}
/**
 * Updates a referred friend. Supports partial updates.
 *
 * You must pass the latest `revision` for a successful update.
 */
export function updateReferredFriend(payload) {
    var _a = serializer(_updateReferredFriendRequest, { _referredFriend: _referredFriend }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReferredFriendResponse, {
        _referredFriend: _referredFriend,
    }).fromJSON;
    function __updateReferredFriend(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referred_friend',
            method: 'PATCH',
            methodFqn: 'wix.loyalty.referral.friend.v1.ReferredFriends.UpdateReferredFriend',
            url: resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl({
                protoPath: '/v1/referred-friends/{referredFriend.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReferredFriend.fromReq = fromReq;
    __updateReferredFriend.__isAmbassador = true;
    return __updateReferredFriend;
}
/** Deletes a referred friend. */
export function deleteReferredFriend(payload) {
    var _a = serializer(_deleteReferredFriendRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteReferredFriendResponse, {}).fromJSON;
    function __deleteReferredFriend(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referred_friend',
            method: 'DELETE',
            methodFqn: 'wix.loyalty.referral.friend.v1.ReferredFriends.DeleteReferredFriend',
            url: resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl({
                protoPath: '/v1/referred-friends/{referredFriendId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReferredFriend.fromReq = fromReq;
    __deleteReferredFriend.__isAmbassador = true;
    return __deleteReferredFriend;
}
/**
 * Retrieves a list of referred friends, given the provided paging, filtering, and sorting.
 *
 * This endpoint supports [WQL (Wix Query Language)](https://dev.wix.com/api/rest/getting-started/api-query-language).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryReferredFriend(payload) {
    var _a = serializer(_queryReferredFriendRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReferredFriendResponse, {
        _referredFriend: _referredFriend,
    }).fromJSON;
    function __queryReferredFriend(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referred_friend',
            method: 'POST',
            methodFqn: 'wix.loyalty.referral.friend.v1.ReferredFriends.QueryReferredFriend',
            url: resolveWixLoyaltyReferralFriendV1ReferredFriendsUrl({
                protoPath: '/v1/referred-friends/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReferredFriend.fromReq = fromReq;
    __queryReferredFriend.__isAmbassador = true;
    return __queryReferredFriend;
}
//# sourceMappingURL=http.impl.js.map